import * as React from "react";
import { FlexGrid as FlexGridCore, IFlexGridProps as IFlexGridPropsCore } from "@webbio/components";

const FlexGrid = (props: IFlexGridPropsCore): JSX.Element => {
  return <FlexGridCore {...props} />;
};

export { FlexGrid };
